export const truncateText = (text, length) => {
    if (!text || text.length <= length) {
        return text;
    }
    const shortText = text.substr(0, length)
    const arr = shortText.split(" ")
    arr.pop();
    const joined = arr.join(' ');

    return joined + '\u2026'
}
